export const digitalProofingKeys = {
  all: ['digital-proofing'] as const,

  previewStatus: {
    all: ['digital-proofing', 'preview-status'] as const,
    byProductId: (productId: number) => [...digitalProofingKeys.previewStatus.all, productId] as const
  }
}
